module.exports = __webpack_public_path__ + "img/point-to.3d7d7071.png";